import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-default-cell',
  templateUrl: './default-cell.component.html',
  standalone: false,
})
export class DefaultCellComponent {
  @Input() columnName: string;
  @Input() element: any;
  @Input() parseLinks = false;
}
